import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from './../auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: 'app-forgot-passwordpopup',
  templateUrl: './forgot-passwordpopup.component.html',
  styleUrls: ['./forgot-passwordpopup.component.scss']
})
export class ForgotPasswordpopupComponent implements OnInit {
  forgotpasswordForm: FormGroup;
  submitted: boolean;
  constructor(
    private fb: FormBuilder,
    private ngxService: NgxUiLoaderService,

    public dialogRef: MatDialogRef<ForgotPasswordpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private toastr: ToastrService,
  ) {
    this.forgotpasswordForm = this.fb.group({
      email: ['', Validators.required],
    });
  }

  ngOnInit(): void {
  }
  get f() { return this.forgotpasswordForm.controls; }
  forgotpass() {
    this.ngxService.start();

    this.submitted = true;
    if (!this.forgotpasswordForm.value.email) {
      return;
    }
    this.authService.forgetPassword(this.forgotpasswordForm.value).subscribe((emailRes: any) => {
      this.ngxService.stop();

      if (emailRes.status == '400') {
        this.dialogRef.close();
        this.toastr.error(emailRes.message, '');
      }
      else if (emailRes.status == '404') {
        this.dialogRef.close();
        this.toastr.error(emailRes.message, '');
      }
       else {
        this.dialogRef.close();
        this.toastr.success(emailRes.message, '');
      }

    },err=>{
      this.dialogRef.close();
      this.toastr.error(err.error.message);

    })
  }
  closepopUp() {
    this.dialogRef.close();
  }
}
